import axios from '@/http/httpConfig'

export function getvCode() {
  return axios.get('/topsystem/vcode')
}
export function accountLogin(data) {
  return axios.agentPost('/user/login', data)
}

export function getSmsvCode(data) {
  return axios.agentPost('topsystem/smsvcode', data)
}

export function login(data) {
  return axios.agentPost('user/mobile/sms', data)
}

export function getToken(data) {
  return axios.agentPost('api/oauth2/access_token', data)
}

export function getDepartment() {
  return axios.get('account_user/department')
}
export function getPositionList(data) {
  return axios.get('/position', data)
}
export function getUser(data) {
  return axios.get('user', data)
}

// 获取会话列表(不分页)
export function getImDialogueAllList(data) {
  return axios.get('/im/dialogue/alllist', data)
}
// 招聘进度
export function jobProgress(data) {
  return axios.get('/statistics/department/progress', data)
}
export function getCollageDetails(collegeid) {
  return axios.get('/college/' + collegeid)
}

// 根据条件搜索简历
export function getSearchResumeList(data) {
  return axios.get('/resume/searcher', data)
}
// 获取当前高校的宣讲会申请记录/campustalk/{collegeid}/apply/list
export function getCampustalkByCollegeid(collegeid, data) {
  return axios.get('/campustalk/' + collegeid + '/apply/list', data);
}

// 获取高校招聘会列表
export function getMilkRoundList(collegeid, data) {
  return axios.get('milkround/college/' + collegeid + '/department/list', data);
}
export function getDictDate(_dicttype) {
  return axios.get('dict/' + _dicttype);
}
// 根据名称模糊匹配返回字典
export function getSearchListDic(_dicttype, data) {
  return axios.get('dict/' + _dicttype + '/matching?name=' + data.name + '&level=' + data.level)
}
// 发布职位
export function createPosition(data) {
  return axios.post('position/create', data);
}

// 职位重发
export function managePositionResend(_positionid) {
  return axios.post('position/' + _positionid + '/online')
}
// 修改职位
export function updatePosition(_positionid, data) {
  return axios.post('position/' + _positionid + '/update', data);
}

// 删除职位
export function deletePosition(_positionid) {
  return axios.post('position/' + _positionid + '/delete')
}
// 根据职位positionid获取职位详情
export function getPostDetails(_positionid) {
  return axios.get('position/' + _positionid)
}
// 职位下线
export function managePositionExpired(_positionid) {
  return axios.post('position/' + _positionid + '/expired')
}
export function getWechatInfo(data) {
  return axios.post('wechat/talent/jssdk/authorize',data)
}
export function checkPhoneWithCode(data) {
  return axios.agentPost('/topsystem/smsvcode/verify', data)
}
export function sendSms(data) {
  return axios.agentPost('/topsystem/smsvcode/app', data)
}
export function getTalentUser() {
  return axios.get('account_user/talent')
}
export default {
  getvCode: getvCode,
  accountLogin: accountLogin,
  getSmsvCode: getSmsvCode,
  getToken: getToken,
  getDepartment: getDepartment,
  getPositionList: getPositionList,
  getUser: getUser,
  getImDialogueAllList: getImDialogueAllList,
  jobProgress: jobProgress,
  getCollageDetails: getCollageDetails,
  getSearchResumeList: getSearchResumeList,
  getCampustalkByCollegeid: getCampustalkByCollegeid,
  getMilkRoundList: getMilkRoundList,
  getSearchListDic: getSearchListDic,
  getDictDate: getDictDate,
  createPosition: createPosition,
  managePositionResend: managePositionResend,
  deletePosition: deletePosition,
  getPostDetails: getPostDetails,
  updatePosition: updatePosition,
  managePositionExpired: managePositionExpired,
  checkPhoneWithCode: checkPhoneWithCode,
  sendSms: sendSms,
  getTalentUser: getTalentUser,
  getWechatInfo: getWechatInfo
}



// WEBPACK FOOTER //
// ./src/http/baseApi.js